import { render, staticRenderFns } from "./GroupManage.vue?vue&type=template&id=3e10af0e&scoped=true&"
import script from "./GroupManage.vue?vue&type=script&lang=js&"
export * from "./GroupManage.vue?vue&type=script&lang=js&"
import style0 from "./GroupManage.vue?vue&type=style&index=0&id=3e10af0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e10af0e",
  null
  
)

export default component.exports